import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
// import Link from '@material-ui/core/Link';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Title from '../Title';
import moment from "moment";

const useStyles = makeStyles({
  depositContext: {
    marginTop: -5,
    marginBottom: 10
  },
});

export default function TurnosDelDia() {
  const classes = useStyles();
  const [ tomados, setTomados ] = React.useState(0);
  const [ libres, setLibres ] = React.useState(0);

  const { itemsEstadoTurnos } = useSelector( (state) => state.indicadores );

  useEffect (() => {
    if(itemsEstadoTurnos){
      setTomados(itemsEstadoTurnos?.reduce((a,v) =>  a = a + v.tomados , 0));
      setLibres(itemsEstadoTurnos?.reduce((a,v) =>  a = a + v.libres , 0));
    }
  }, [itemsEstadoTurnos])

  return (
    <React.Fragment>
      <Title>Turnos del Día</Title>
      <Typography color="textSecondary" className={classes.depositContext}>
        {moment().format('LL')}
      </Typography>

      <Typography component="p" variant="h4" >
        {tomados + libres} 
      </Typography>
      <Typography component="h6" variant="h6">
        {`Tomados ${tomados}`} 
      </Typography>
      <Typography component="h6" variant="h6">
        {`Libres ${libres}`} 
      </Typography>
      
      {/* <div>
        <Link color="primary" href="#" onClick={preventDefault}>
         Ampliar Info
        </Link>
      </div> */}
    </React.Fragment>
  );
}